import { Component } from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-loading',
  imports: [
    MatProgressSpinner,
  ],
  templateUrl: './loading.component.html',
  standalone: true,
  styleUrl: './loading.component.scss'
})
export class LoadingComponent {

}
